"use client";

import ProductHeroBase from "@/components/sections/products/shared/hero-base";
import { mobileStats } from "../data";

export default function MobilePricingHero() {
  return (
    <ProductHeroBase
      headingId="pricing-hero-heading"
      eyebrow="Mobile Proxies — Pricing"
      headingLine1="The only mobile proxies"
      headingLine2="you'll ever need."
      description="Premium, ethically sourced mobile IPs. Pay per GB, scale as you go. No contracts, no hidden fees."
      trustBadges={["KYC required", "30-day money-back guarantee"]}
      stats={mobileStats}
      scrollIndicator={{ label: "See plans", href: "#pricing-plans" }}
    />
  );
}
